import React, { useState, useEffect } from 'react';
import Menu from '../Menu'


const ReportShareNoAlarm = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [sum, setSum] = useState(0);

    useEffect(() => {
        // Replace with your API endpoint
        

        const mytoken=sessionStorage.getItem('google_token');
        const apiUrl = 'https://app64.heliohost.us/api/getreports.php?oper=share_noalarms';
        //const apiUrl = 'http://localhost/api/getShareAlarms.php';

        
        fetch( apiUrl,{
            method:"GET",          
            headers:{
                "Content-Type": "application/json",
                "AuthCode" : mytoken
            }
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }
                return response.json();
            })
            .then((data) => {
                setData(data);
                setLoading(false);
                const totalSum = data.reduce((sum, item) => sum + 1*item.amounteuro, 0);

                
                setSum(totalSum.toFixed(2));


                
                
            })
            .catch((error) => {
                console.error("Error:", error);
                setError(error.message);
                setLoading(false);
            });
    }, []); // Empty dependency array means this runs once on component mount

    if (loading) {
        return <p>Loading...</p>;
    }

    if (error) {
        return <p>Error: {error}</p>;
    }

    return (
        <div>
            <Menu/>
            <h1>Data Table</h1>
            <table border="1" cellPadding="10" cellSpacing="0">
                <thead>
                    <tr>
                        <th>symb</th>
                        <th>platform</th>                        
                        <th>symb_platform</th>
                        <th>amount</th>
                        <th>currency</th>
                        <th>typeshare</th>                        
                        <th>details</th>                        
                        
                        
                    </tr>
                </thead>
                <tbody>
                    {data.map((item) => (
                        <tr key={item.platform}>                            
                            
                            <td>{item.symb}</td>
                            <td>{item.platform}</td>
                            <td>{item.symb_platform}</td>
                            <td>{item.amount}</td>
                            <td>{item.currency}</td>
                            <td>{item.typeshare}</td>
                            <td>{item.details}</td>                                                        
                        </tr>
                    ))}
                </tbody>
            </table>
            <div>
                <b>Total {sum} euro</b>
            </div>
        </div>
    );
};

export default ReportShareNoAlarm